import { Reveal, Overline } from "@/components/Reveal";

const chapters = [
  {
    n: "01",
    title: "Attentive Service",
    text: "Customers frequently mention polite staff who listen first — what you want, what suits you, and what fits your time.",
  },
  {
    n: "02",
    title: "Clean & Comfortable",
    text: "Customers frequently mention hygiene, clean equipment and a relaxing atmosphere — the small things that make a visit feel easy.",
  },
  {
    n: "03",
    title: "Beauty for Every Occasion",
    text: "From a quick cleanup to a full bridal look, services are planned around your day, your style and your comfort.",
  },
];

export default function WhyUs() {
  return (
    <section className="py-20 md:py-32 bg-soft" data-testid="why-us-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <Reveal>
          <Overline>Why Choose Us</Overline>
          <h2 className="mt-4 font-display text-4xl sm:text-5xl tracking-tight text-ink max-w-2xl">
            A Beauty Experience That Feels Personal
          </h2>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8">
          {chapters.map((c, i) => (
            <Reveal key={c.n} delay={i * 0.12}>
              <article data-testid={`why-card-${i}`} className="border-t-2 border-primary/20 pt-6">
                <span className="font-display text-7xl leading-none text-accent/40" aria-hidden="true">
                  {c.n}
                </span>
                <h3 className="mt-4 font-display text-2xl text-ink">{c.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-muted-foreground">{c.text}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
